// Generated by purs version 0.15.16
import * as API_Pagination from "../API.Pagination/index.js";
import * as API_Search from "../API.Search/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
var toVars = /* #__PURE__ */ GraphQL_Query.toVars(API_Search.toVarsSearchVars);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(encRNTY);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Internal_Luxon.decodeLDT));
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(created_atIsSymbol)()())())));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var gDecodeJsonCons3 = /* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var lockIsSymbol = {
    reflectSymbol: function () {
        return "lock";
    }
};
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons5 = /* #__PURE__ */ gDecodeJsonCons4(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var gDecodeJsonCons6 = /* #__PURE__ */ gDecodeJsonCons5(nameIsSymbol)()();
var companyIsSymbol = {
    reflectSymbol: function () {
        return "company";
    }
};
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var createIsSymbol = {
    reflectSymbol: function () {
        return "create";
    }
};
var useDefaultIsSymbol = {
    reflectSymbol: function () {
        return "useDefault";
    }
};
var saveDefaultIsSymbol = {
    reflectSymbol: function () {
        return "saveDefault";
    }
};
var requestIsSymbol = {
    reflectSymbol: function () {
        return "request";
    }
};
var gDecodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons3(useDefaultIsSymbol)()())(updateIsSymbol)()())(saveDefaultIsSymbol)()())(requestIsSymbol)()())(createIsSymbol)()())()));
var relationship_labelIsSymbol = {
    reflectSymbol: function () {
        return "relationship_label";
    }
};
var relationshipIsSymbol = {
    reflectSymbol: function () {
        return "relationship";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var emailLabelIsSymbol = {
    reflectSymbol: function () {
        return "emailLabel";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var typeIsSymbol = {
    reflectSymbol: function () {
        return "type";
    }
};
var signaturesIsSymbol = {
    reflectSymbol: function () {
        return "signatures";
    }
};
var priorityIsSymbol = {
    reflectSymbol: function () {
        return "priority";
    }
};
var mutationsIsSymbol = {
    reflectSymbol: function () {
        return "mutations";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var bgColorIsSymbol = {
    reflectSymbol: function () {
        return "bgColor";
    }
};
var abbrIsSymbol = {
    reflectSymbol: function () {
        return "abbr";
    }
};
var gDecodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons10 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT));
var gDecodeJsonCons11 = /* #__PURE__ */ gDecodeJsonCons7(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var default_last_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_last_name";
    }
};
var default_first_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_first_name";
    }
};
var default_emailIsSymbol = {
    reflectSymbol: function () {
        return "default_email";
    }
};
var gDecodeJsonCons12 = /* #__PURE__ */ gDecodeJsonCons11(keyIsSymbol)()();
var colorIsSymbol = {
    reflectSymbol: function () {
        return "color";
    }
};
var tagsIsSymbol = {
    reflectSymbol: function () {
        return "tags";
    }
};
var preferred_nameIsSymbol = {
    reflectSymbol: function () {
        return "preferred_name";
    }
};
var last_imported_atIsSymbol = {
    reflectSymbol: function () {
        return "last_imported_at";
    }
};
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var verificationsIsSymbol = {
    reflectSymbol: function () {
        return "verifications";
    }
};
var updated_atIsSymbol = {
    reflectSymbol: function () {
        return "updated_at";
    }
};
var subtitleIsSymbol = {
    reflectSymbol: function () {
        return "subtitle";
    }
};
var studentIsSymbol = {
    reflectSymbol: function () {
        return "student";
    }
};
var signature_fieldsIsSymbol = {
    reflectSymbol: function () {
        return "signature_fields";
    }
};
var locked_atIsSymbol = {
    reflectSymbol: function () {
        return "locked_at";
    }
};
var legacy_urlIsSymbol = {
    reflectSymbol: function () {
        return "legacy_url";
    }
};
var form_typeIsSymbol = {
    reflectSymbol: function () {
        return "form_type";
    }
};
var exportsIsSymbol = {
    reflectSymbol: function () {
        return "exports";
    }
};
var employerIsSymbol = {
    reflectSymbol: function () {
        return "employer";
    }
};
var contactIsSymbol = {
    reflectSymbol: function () {
        return "contact";
    }
};
var commentsIsSymbol = {
    reflectSymbol: function () {
        return "comments";
    }
};
var attachmentsIsSymbol = {
    reflectSymbol: function () {
        return "attachments";
    }
};
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons3(updateIsSymbol)()())(lockIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons6)()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons5(companyIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5(urlIsSymbol)()())(labelIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5(updateIsSymbol)()())(deleteIsSymbol)()())(createIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons5(relationship_labelIsSymbol)()())(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())(canIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons5(typeIsSymbol)()())(signaturesIsSymbol)()())(priorityIsSymbol)()())(mutationsIsSymbol)()())(labelIsSymbol)()())(idIsSymbol)()())(bgColorIsSymbol)()())(abbrIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons10(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons11(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())(default_last_nameIsSymbol)()())(default_first_nameIsSymbol)()())(default_emailIsSymbol)()())(canIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons12)())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons10(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons6)(colorIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(tagsIsSymbol)()())(preferred_nameIsSymbol)()())(nameIsSymbol)()())(last_imported_atIsSymbol)()())(idIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons12)(emailIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(dataIsSymbol)()())(created_atIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(verificationsIsSymbol)()())(updated_atIsSymbol)()())(subtitleIsSymbol)()())(studentIsSymbol)()())(signaturesIsSymbol)()())(signature_fieldsIsSymbol)()())(locked_atIsSymbol)()())(legacy_urlIsSymbol)()())(idIsSymbol)()())(form_typeIsSymbol)()())(exportsIsSymbol)()())(employerIsSymbol)()())(contactIsSymbol)()())(commentsIsSymbol)()())(canIsSymbol)()())(attachmentsIsSymbol)()())();
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var rlhsCons1 = /* #__PURE__ */ rlhsCons(keyIsSymbol)(GraphQL_Shape.scalarShape)()();
var rlhsCons2 = /* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()();
var maybeShape = /* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape);
var recShape = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(useDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(updateIsSymbol)(GraphQL_Shape.scalarShape)()())(saveDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(requestIsSymbol)(GraphQL_Shape.scalarShape)()())(createIsSymbol)(GraphQL_Shape.scalarShape)()())();
var rlhsCons3 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updateIsSymbol)(GraphQL_Shape.scalarShape)()());
var arrayShape = /* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())());
var recShape1 = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(verificationsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(dataIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(rlhsCons1)(emailIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(updated_atIsSymbol)(GraphQL_Shape.scalarShape)()())(subtitleIsSymbol)(GraphQL_Shape.scalarShape)()())(studentIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(tagsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(rlhsCons2)(colorIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(preferred_nameIsSymbol)(maybeShape)()())(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(last_imported_atIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(signaturesIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(rlhsCons1)()))()())(signature_fieldsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(relationshipIsSymbol)(GraphQL_Shape.scalarShape)()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(emailLabelIsSymbol)(GraphQL_Shape.scalarShape)()())(default_last_nameIsSymbol)(maybeShape)()())(default_first_nameIsSymbol)(maybeShape)()())(default_emailIsSymbol)(maybeShape)()())(canIsSymbol)(recShape)()())()))()())(locked_atIsSymbol)(maybeShape)()())(legacy_urlIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(form_typeIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(typeIsSymbol)(GraphQL_Shape.scalarShape)()())(signaturesIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(relationship_labelIsSymbol)(GraphQL_Shape.scalarShape)()())(relationshipIsSymbol)(GraphQL_Shape.scalarShape)()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(emailLabelIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(recShape)()())()))()())(priorityIsSymbol)(GraphQL_Shape.scalarShape)()())(mutationsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons3(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())(createIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(bgColorIsSymbol)(GraphQL_Shape.scalarShape)()())(abbrIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(exportsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(urlIsSymbol)(GraphQL_Shape.scalarShape)()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(employerIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(companyIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(contactIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(/* #__PURE__ */ GraphQL_Shape.recShape(rlhsCons2)()))()())(commentsIsSymbol)(arrayShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons3(lockIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(attachmentsIsSymbol)(arrayShape)()())();
var map1 = /* #__PURE__ */ Data_Functor.map(GraphQL_Query.queryFunctor);
var rltvCons = /* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil);
var idsIsSymbol = {
    reflectSymbol: function () {
        return "ids";
    }
};
var rntyType = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
});
var rltvfConsOther = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil);
var formsIsSymbol = {
    reflectSymbol: function () {
        return "forms";
    }
};
var buildQuery = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(idsIsSymbol)(/* #__PURE__ */ GraphQL_Type.hqtArray(rntyType))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encRNTY))()())(/* #__PURE__ */ rltvfConsOther(idsIsSymbol)())())(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(formsIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(formsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(recShape1))()())()));
var buildQuery1 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(idIsSymbol)(rntyType)(encRNTY)()())(/* #__PURE__ */ rltvfConsOther(idIsSymbol)())())(/* #__PURE__ */ GraphQL_Query.jsonQR(decodeRecord)(recShape1));
var FormSearchQuery = /* #__PURE__ */ (function () {
    function FormSearchQuery(value0) {
        this.value0 = value0;
    };
    FormSearchQuery.create = function (value0) {
        return new FormSearchQuery(value0);
    };
    return FormSearchQuery;
})();
var toVarsFormSearchQuery = {
    toVars: function (v) {
        if (v.value0.formIds.length === 0) {
            return toVars(API_Search.queryVars(v.value0));
        };
        return append(toVars(API_Search.queryVars(v.value0)))([ new GraphQL_Query.QueryVar("type_id", new GraphQL_Type.ArrayOf(new GraphQL_Type.QType("ID"))) ]);
    },
    encodeVars: function (v) {
        if (v.value0.formIds.length === 0) {
            return API_Search["queryObj$prime"](v.value0);
        };
        return Foreign_Object.insert("type_id")(Data_Argonaut_Core.fromArray(map(encodeJson)(v.value0.formIds)))(API_Search["queryObj$prime"](v.value0));
    },
    varFiles: function (v) {
        return [  ];
    }
};
var searchRecentForms = /* #__PURE__ */ (function () {
    var $791 = GraphQL_Query.nameQuery("RecentForms");
    var $792 = GraphQL_Query.buildQuery(toVarsFormSearchQuery)(API_Pagination.pageQR(decodeRecord)(recShape1))("recentForms");
    return function ($793) {
        return $791($792($793));
    };
})();
var fetchRecentFormsByIds = function (ids) {
    return GraphQL_Query.nameQuery("RecentFormsByIds")(map1(function (v) {
        return v.forms;
    })(buildQuery("forms")({
        ids: ids
    })));
};
var fetchRecentFormById = function (id) {
    return GraphQL_Query.nameQuery("RecentForm")(buildQuery1("form")({
        id: id
    }));
};
var emptyFormQuery = /* #__PURE__ */ (function () {
    return new FormSearchQuery({
        teacher: Data_Maybe.Nothing.value,
        semester: Data_Maybe.Nothing.value,
        search: Data_Maybe.Nothing.value,
        "class": Data_Maybe.Nothing.value,
        formIds: [  ]
    });
})();
export {
    emptyFormQuery,
    FormSearchQuery,
    searchRecentForms,
    fetchRecentFormsByIds,
    fetchRecentFormById,
    toVarsFormSearchQuery
};
//# sourceMappingURL=index.js.map
